module.exports = __webpack_public_path__ + "img/6ac7ddb39c3f40f5ac41fcedf919e091.ee0a0ae1.jpg";